<div class="dcf-hero dcf-hero-default">
  <!-- TemplateEndEditable -->
  <div class="dcf-hero-group-1">
    <div class="dcf-breadcrumbs-wrapper">
      <nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
        <!-- TemplateBeginEditable name="breadcrumbs" -->
        <ol>
          <li><a href="https://www.unl.edu/">Nebraska</a></li>
          <li><a href="/">TCAN / VITA Lincoln</a></li>
          <li><a href="/management">Management</a></li>
          <li><span aria-current="page">Appointment Management</span></li>
        </ol>
        <!-- TemplateEndEditable -->
      </nav>
    </div>
    <header class="dcf-page-title" id="dcf-page-title">
      <!-- TemplateBeginEditable name="pagetitle" -->
      <h1>Appointment Management</h1>
      <!-- TemplateEndEditable -->
    </header>
    <!-- TemplateBeginEditable name="herogroup1" -->
    <!-- TemplateEndEditable -->
  </div>
  <!-- TemplateBeginEditable name="herogroup2" -->
  <div class="dcf-hero-group-2">
  </div>
  <!-- TemplateEndEditable -->
</div>

<div class="dcf-main-content dcf-wrapper">
  <!-- Show when an appointment is selected -->
  <div class="dcf-wrapper" [hidden]="appointment === null" ng-cloak>

    <!-- Provide a way back to list of appointments -->
    <button type="button" class="dcf-btn dcf-btn-secondary dcf-mb-8" (click)="deselectAppointment()">Back to List of Appointments</button>

    <!-- Information Section -->
    <h2 class="client-name">{{appointment?.client.firstName}} {{appointment?.client.lastName}}</h2>
    <div class="dcf-grid-halves@md">
      <div>
        <div><b>Scheduled Appointment Time: </b>{{appointment?.appointment_time?.scheduledTimePretty}}</div>
        <div><b>Site: </b>{{appointment?.site?.title}}</div>
        <div><b>Requested Language: </b>{{appointment?.language == "Other" ? " "+appointment?.answersByLookup?.otherLanguage?.answer : appointment?.language}}</div>
        <div><b>Requested Translator: </b>{{appointment?.answersByLookup?.translator?.answer}}</div>
        @if (appointment?.client.emailAddress != null) {
          <div>
            <span><b>Email: </b>{{appointment?.client.emailAddress}}</span>
          </div>
        }
        @if (appointment?.client.phoneNumber != null) {
          <div>
            <span><b>Phone Number: </b>{{appointment?.client.phoneNumber}}</span>
          </div>
        }
        @if (appointment?.client.bestTimeToCall != null) {
          <div>
            <span><b>Best Time to Call: </b>{{appointment?.client.bestTimeToCall}}</span>
          </div>
        }
        <div><b>Tax Type: </b>{{appointment?.appointmentType}}</div>
      </div>

      <div>
        <div><b>Status: </b><span
        ng-class="{'status-in-progress': appointment?.inProgress || !appointment?.started, 'status-incomplete': appointment?.incomplete || appointment?.serviced_appointment.cancelled, 'status-complete': appointment?.completed}">
        {{appointment?.statusText}}
      </span></div>
      <div><b>Time Arrived: </b>{{appointment?.serviced_appointment?.timeIn != null ? appointment?.serviced_appointment?.timeIn : "N/A"}}</div>
      <div><b>Time Paperwork Completed: </b>{{appointment?.serviced_appointment?.timeReturnedPapers != null ? appointment?.serviced_appointment?.timeReturnedPapers : "N/A"}}</div>
      <div><b>Time Appointment Started: </b>{{appointment?.serviced_appointment?.timeAppointmentStarted != null ? appointment?.serviced_appointment?.timeAppointmentStarted : "N/A"}}</div>
      <div><b>Time Appointment Ended: </b>{{appointment?.serviced_appointment?.timeAppointmentEnded != null ? appointment?.serviced_appointment?.timeAppointmentEnded : "N/A"}}</div>
      <div><b>Appointment ID: </b>{{appointment?.appointmentId}}</div>
    </div>
  </div>
  <div>
    @if (appointment?.uniqueAppointmentRescheduleUrl != null) {
      <div><b>Unique Appointment Reschedule URL: </b><a [href]="appointment?.uniqueAppointmentRescheduleUrl" target="_blank">{{appointment?.uniqueAppointmentRescheduleUrl}}</a></div>
    }
    @if (appointment?.uniqueUploadDocumentsUrl != null) {
      <div><b>Unique Upload Documents URL: </b><a [href]="appointment?.uniqueUploadDocumentsUrl" target="_blank">{{appointment?.uniqueUploadDocumentsUrl}}</a></div>
    }
  </div>



  <!-- Notes Area -->
  <div appointment-notes-area class="dcf-mt-5"></div>
  <!-- End Notes Area -->



  <!-- Reschedule Section -->
  <h3 class="dcf-mt-5">Reschedule Appointment</h3>
  <form class="cmxform" id="rescheduleForm">

    <label for="appointmentTypeSelect" class="form-label form-required">Appointment Type</label>
    <select id="appointmentTypeSelect"
      name="appointmentTypeSelect"
      class="dropdown-toggle dcf-input-select"
      [(ngModel)]="appointmentType"
      required>
      <option value="" style="display:none;">-- Select An Appointment Type --</option>
      @for (option of appointmentTypes; track option) {
        <option [value]="option.lookupName" [selected]="option.lookupName === appointmentType">{{option.name}}</option>
      }
    </select>
    <p class="dcf-txt-xs">This dropdown defaults to the type of this appointment, only change if necessary</p>

    <app-appointment-picker
      [appointmentType]="appointment?.appointmentType ?? ''"
    ></app-appointment-picker>
    <br/>
    <div class="dcf-mb-5">
      <input type="submit"
        value="Reschedule"
        name="rescheduleButton"
        id="rescheduleButton"
        class="submit dcf-btn dcf-btn-primary"
        [disabled]="!nullSettings() || submittingReschedule"
        (click)="rescheduleAppointment()">

      <!-- Cancel Button -->
      <button id="confirm-cancel-modal-opener"
        class="submit dcf-btn dcf-btn-secondary"
        [hidden]="appointment?.started || appointment?.cancelled"
        (click)="openCancelling()"
      >Cancel Appointment</button>
    </div>

    <p>An email will automatically be sent to the client with the rescheduled information if the client has an email on record.</p>


  </form>

</div>

<!-- Show if no selected appointment -->
@if (appointments != null && appointment === null) {
  <div ng-cloak>
    @if (appointments.length > 0) {
      <div>
        <!-- Search box -->
        <div class="appointment-search dcf-wrapper dcf-txt-center" id="search_filters">
          <div id="search_string">
            <label class="dcf-label" for="queue-search">Search by name or appt ID</label>
            &nbsp;
            <input class="dcf-input-text dcf-d-inline" id="queue-search" name="queue-search" type="text" [(ngModel)]="appointmentSearch" (changed)="filteredAppointments()" />
          </div>
          <div id="search_site">
            <label class="dcf-label" for="site_search">Show Site</label>
            &nbsp;
            <select id="sitePickerSelect"
              class="dcf-input-select dcf-mb-0"
              name="sitePickerSelect"
              id="site_search"
              [(ngModel)]="appointmentSearchSite"
              >
                <option disabled selected hidden>Select a Site</option>
                <option value="American Job Center">American Job Center</option>
                <option value="Victor Anderson Library">Victor Anderson Library</option>
                <option value="Loren Eiseley Library">Loren Eiseley Library</option>
                <option value="Asian Community and Culture Center">Asian Community and Culture Center</option>
                <option value="Southeast Community College">Southeast Community College</option>
                <option value="Nebraska East Union">Nebraska East Union</option>
                <option value="Bennett Martin Library">Bennett Martin Library</option>
                <option value="Good Neighbor Center">Good Neighbor Center</option>
                <option value="Hastings Public Library">Hastings Public Library</option>
                <option value="Grand Island - Multicultural Coalition">Grand Island - Multicultural Coalition</option>
                <option value="Airpark Community Center">Airpark Community Center</option>
              </select>
          </div>
          <div id="search_translator">
            <label class="dcf-label" for="translator_search">Needs Translator</label>
            &nbsp;
            
            <select id="sitePickerSelect"
              class="dcf-input-select dcf-mb-0"
              id="translator_search"
              [(ngModel)]="appointmentSearchTranslator"
              >
                <option>Any</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
          </div>
          <!-- <app-custom-radio-button
            question=""
            name="isVirtualName"
            [(ngModel)]="displayCanceled"
            (change)="test()"
            [buttons]="cancelledButtons"
            [hidden]="(appointments | searchFor: appointmentSearch).length <= 0"
          ></app-custom-radio-button> -->
          <div id="search_buttons">
            <button class="dcf-btn dcf-btn-secondary" (click)="toggleDisplayCanceled()" >
              @if(displayCanceled) {
                Hide 
              }
              @else {
                Show
              }
              Canceled
            </button>
            <button class="dcf-btn dcf-btn-secondary" (click)="toggleDisplayComplete()" >
              @if(displayComplete) {
                Hide 
              }
              @else {
                Show
              }
              Completed
            </button>
          </div>
       
        </div>
        <!-- Show when there's no search results -->
        <p class="dcf-wrapper dcf-txt-center unl-font-sans"
          [hidden]="(appointments | searchFor: appointmentSearch).length > 0">
          No results for "{{appointmentSearch}}"
        </p>
        <!-- List of appointments  -->
        <table class="dcf-table dcf-table-striped queue dcf-ml-5 dcf-mr-5" [hidden]="(appointments | searchFor: appointmentSearch).length <= 0" id="appts_table">
          <tbody>
            <tr>
              <th>Name</th>
              <th>Site</th>
              <th>Scheduled Time</th>
              <th>Language</th>
              <th>Appointment ID</th>
              <th>Appointment Status</th>
            </tr>
            @for (appointment of filteredAppointments(); track appointment) {
              <tr class="pointer"
                (click)="selectAppointment(appointment)">
                <td data-header="Name">{{appointment.client.firstName}} {{appointment.client.lastName}}</td>
                <td data-header="Site">{{appointment.site.title}}</td>
                <td data-header="Scheduled Time">{{appointment.appointment_time.scheduledTimePretty}}</td>
                <td data-header="Language">{{appointment.language}}</td>
                <td data-header="Appointment ID">&#35;{{appointment?.appointmentId}}</td>
                <td data-header="Appointment Status">{{appointment.progressionStepName}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (isLoading && appointments.length == 0) {
      <div class="dcf-wrapper dcf-txt-center unl-font-sans">
        Loading...
      </div>
    }
    @else if (appointments.length == 0) {
      <div class="dcf-wrapper dcf-txt-center unl-font-sans">
        There are no appointments.
      </div>
    }
  </div>
}
</div>